export class OptionButton {
}
export class TypeCard {
}
